import React from "react";
import MetaResolver from "components/seo/MetaResolver";
import { logoUrl, origin } from "components/index/Config";

export interface MetaProps {
  title?: string;
  robots?: string;
  description?: string;
  keywords?: string;
  url?: string;
  image?: string;
}

export interface SeoProps {
  lang: string,
  meta: MetaProps,
  richSnippets?: object | string,
  children?: React.ReactNode;
}

const Seo = ({ lang, meta, richSnippets, children }: SeoProps) => {
  const {
    title: defaultTitle,
    keywords: defaultKeywords,
    description: defaultDescription,
    og
  } = MetaResolver(lang);

  return (
    <>
      <title>{meta.title ?? defaultTitle}</title>
      <link rel="icon"
            type="image/svg+xml"
            href={`${origin}/favicon.svg`}
      />
      <link rel="alternate icon"
            href={`${origin}/favicon.svg`}
      />
      <meta name="robots"
            content={meta.robots ?? "index,follow"}
      />
      <meta
        name="description"
        content={meta.description ?? defaultDescription}
      />
      <meta name="keywords"
            content={meta.keywords ?? defaultKeywords}
      />
      <meta property="og:title"
            content={meta.title ?? defaultTitle}
      />
      <meta
        property="og:description"
        content={meta.description ?? defaultDescription}
      />
      <meta property="og:url"
            content={meta.url ?? origin}
      />
      <meta property="og:locale"
            content={og.locale}
      />
      <meta property="og:image"
            content={meta.image ?? logoUrl}
      />
      <meta property="og:type"
            content="website"
      />
      {richSnippets ? <></> : <script type="application/ld+json">{richSnippets}</script>}
      {children}
    </>
  );
};

export default Seo;
